<template>
  <div class="section-seats">
    <div class="d-flex align-center justify-space-between" :class="description === null ? 'mb-2' : 'mb-1'">
      <span class="font-weight-bold">{{ panel.sector.name }} · {{ panel.section.name }}</span>
      <t-btn
        v-if="fullScreen"
        icon="mdi-close"
        variant="text"
        aria-label="Fechar"
        @click="emit('close')"
      />
      <t-btn
        v-else
        variant="text"
        size="small"
        prepend-icon="mdi-map-outline"
        @click="emit('close')"
      >
        Ver mapa completo
      </t-btn>
    </div>
    <v-alert
      v-if="description !== null"
      class="sector-description text-caption mb-2"
      icon="mdi-information-outline"
      variant="tonal"
      color="warning"
      density="compact"
    >
      {{ description }}
    </v-alert>
    <div v-if="loading" class="text-medium-emphasis pa-4">
      Carregando lugares…
    </div>
    <template v-else>
      <seat-grid
        :rows="rows"
        :selected="selected"
        :pending="pending"
        @toggle="emit('toggle', $event)"
      />
      <seat-selector-captions :types="seatTypesIn(rows)" />
    </template>
  </div>
</template>

<script setup lang="ts">
import type Row from "@/types/Mapping/Row";
import type Seat from "@/types/Mapping/Seat";
import TBtn from "@/components/core/TBtn.vue";
import SeatGrid from "@/components/Mapping/SeatGrid.vue";
import SeatSelectorCaptions from "@/components/checkout/SeatSelectorCaptions.vue";
import { seatTypesIn } from "@/utils/seatGrid";
import type { SectionPanel } from "@/utils/sectionSelection";

interface Props {
  panel: SectionPanel;
  /** What the event says about the Sector, null when it says nothing. */
  description?: string | null;
  rows: Row[];
  /** The Section's seats are on their way. */
  loading?: boolean;
  /** The seats in the Cart. */
  selected: Seat[];
  /** Ids of the seats waiting on their hold. */
  pending?: string[];
  /** On a phone the Section fills the screen and closes with an X; beside the listing it goes back to the map. */
  fullScreen?: boolean;
}

const { panel, description = null, rows, loading = false, selected, pending = [], fullScreen = false } = defineProps<Props>();

const emit = defineEmits<{
  toggle: [seat: Seat];
  close: [];
}>();

defineOptions({
  name: "SectionSeats",
});
</script>
